import React from "react";
import Background from "../Background";
import Footer from "../Footer";

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <main>
        <Background />
        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
